type IconProps = {
  className?: string
}

export function ArrowIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 20 20" aria-hidden="true">
      <path d="M4 10h11M11 5l5 5-5 5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function ArrowUpIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 20 20" aria-hidden="true">
      <path d="M10 16V5M5 9l5-5 5 5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function MenuIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 8h16M4 16h16" fill="none" stroke="currentColor" strokeLinecap="round" />
    </svg>
  )
}

export function CloseIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" strokeLinecap="round" />
    </svg>
  )
}

export function ViberIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5.2 4.8C6.8 3.4 9 2.8 12 2.8s5.2.6 6.8 2c1.5 1.4 2.2 3.5 2.2 6.3 0 2.6-.6 4.6-1.9 6-1.2 1.3-2.8 2-5 2.2L10.8 22v-2.7c-2.5-.2-4.4-.9-5.7-2.2-1.3-1.4-2-3.4-2-6 0-2.8.7-4.9 2.1-6.3Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.2 7.4c.2 4.5 2.1 6.4 6.5 7l1.4-1.7-2.2-1.3-.9 1.1c-1.6-.6-2.5-1.5-3-3l1.1-.9-1.3-2.2-1.6 1Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.7 6.4c2.1.3 3.3 1.5 3.6 3.6M13.9 8.3c.9.2 1.4.7 1.5 1.5" fill="none" stroke="currentColor" strokeLinecap="round" />
    </svg>
  )
}

export function UpworkIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3.5 6v6.1a3.5 3.5 0 0 0 7 0V6" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.5 9.5c1.3 3.5 3.1 5.2 5.5 5.2 2.6 0 4.5-1.8 4.5-4.4S18.8 6 16.4 6C13.7 6 12 8.2 12 11.6V19" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function WebDevelopmentIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 32 32" aria-hidden="true">
      <rect x="3.5" y="5.5" width="25" height="21" rx="4" fill="none" stroke="currentColor" />
      <path d="M4 11h24M9 8h.1M13 8h.1M12 17l-3 3 3 3M20 17l3 3-3 3M18 15l-4 10" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function MultimediaIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 32 32" aria-hidden="true">
      <rect x="4" y="6" width="24" height="20" rx="5" fill="none" stroke="currentColor" />
      <path d="m14 12 7 4-7 4v-8ZM24 4v4M22 6h4M8 24l4-4 3 3 3-3 6 4" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function AudioIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 32 32" aria-hidden="true">
      <path d="M4 17h3l2-6 4 13 4-17 4 13 2-6 2 3h3" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 6h22a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z" fill="none" stroke="currentColor" />
    </svg>
  )
}
